import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-40a18122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "footer-column" }
const _hoisted_3 = { class: "footer-logo" }
const _hoisted_4 = { class: "footer-tagline" }
const _hoisted_5 = { class: "footer-contact" }
const _hoisted_6 = { class: "footer-social" }
const _hoisted_7 = { class: "footer-column" }
const _hoisted_8 = { class: "footer-title" }
const _hoisted_9 = { class: "footer-links" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-bottom" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Copyright © Kima Home 2021. All Rights Reserved.")
], -1))

import { watch, reactive, ref, onMounted, computed } from "vue";
import store from "@/store";
import commons from "@/utils/Common";
import { COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
import { apiPost, apiGetNoParam, apiRedis } from "@/api/index";

import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  TwitterOutlined
} from '@ant-design/icons-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultFooter',
  setup(__props) {

const companys = ref({
  summary: "",
  sub_name: "",
  address: "",
  phone: "",
  name: "",
  description: "",
  logo: "",
  id: null,
  email: ""
})

onMounted(()=> {
  loadMenuFooter()
  cokiesCompany()
})

const cokiesCompany = () => {
       let data = commons.getCokiesCompany()
        companys.value  = data
}

const isLCompanyInfor = computed(() => {
    return store.getters.isLCompanyInfor;
});
watch(isLCompanyInfor, async (newValue, oldValue) => {
  cokiesCompany()
});

const menuFooter = ref([])

const loadMenuFooter = async () => {
  await apiRedis("default-fotter").then((res) => {
    let response: any = res;
    let data = response.data.data
    if (typeof data === "string") {
      data = JSON.parse(data)
    }
    menuFooter.value = data || []

    console.log("menuFooter", menuFooter.value)
  
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { class: "footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              sm: 12,
              md: 6,
              lg: 6
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h3", _hoisted_3, _toDisplayString(companys.value.sub_name), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(companys.value.summary), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", null, [
                      _createVNode(_unref(EnvironmentOutlined)),
                      _createTextVNode(" " + _toDisplayString(companys.value.address), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_unref(PhoneOutlined)),
                      _createTextVNode(" " + _toDisplayString(companys.value.phone), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_unref(MailOutlined)),
                      _createTextVNode(" " + _toDisplayString(companys.value.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(FacebookOutlined), { class: "social-icon" }),
                    _createVNode(_unref(InstagramOutlined), { class: "social-icon" }),
                    _createVNode(_unref(YoutubeOutlined), { class: "social-icon" }),
                    _createVNode(_unref(TwitterOutlined), { class: "social-icon" })
                  ])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuFooter.value, (menu, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                key: index,
                xs: 24,
                sm: 12,
                md: 6,
                lg: 6
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", _hoisted_8, _toDisplayString(menu.linkLabel), 1),
                    _createElementVNode("ul", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (child, cindex) => {
                        return (_openBlock(), _createElementBlock("li", { key: cindex }, [
                          _createVNode(_component_router_link, {
                            to: child.linkTo
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(child.linkLabel), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_10
      ])
    ]),
    _: 1
  }))
}
}

})